import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

export default function AboutUs() {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };

  return (
    <div className="container mx-auto px-4">
      <div className="lg:grid lg:grid-cols-2 md:grid-cols-1 gap-10">
        <div className="text-right">
          <p className="text-2xl text-white">درباره اسپاد</p>
          <div className="mt-4 text-white text-justify">
            ایده اسپاد از سال 87 از دل اینترنت های Dial-up کارتی بیروت اومد. یه
            شهر کوچیک تو شمال ایران جایی که یه کافی نت با ADSL تو کل شهر بود
            اونم با سرعت 20 کلیوبایت / ثانیه که برای انجام خیلی از کارا مجبور
            بودیم کلی مسیر بریم تو صف بمونیم و کارو انجام بدیم.
          </div>
          <p className="text-2xl text-white mt-20">داستان اسپاد</p>
          <div className="mt-4 text-white text-justify">
            داستان اسپاد از دل یاهو مسنجر میاد جایی تو گروه هاش تبلیغ کردیم،
            اولین کاربرمون رو پیدا کردیم، باهاشون دوست شدیم . بزرگ شدیم. البته
            اسپاد داستان ما از اون زمان با برند دیگه ای فعالیت میکرد. گذشت تا
            اولین شرکتمون رو 3 سال بعد ثبت کردیم. تو سال های بعدش اینقدر بهمون
            عشق دادید که خودمون هم تصورشو نمیکردیم و حتی آمادگیشو نداشتیم و این
            باعث شد خیلی زود خانواده اسپاد بزرگ و بزرگتر بشه.
          </div>
        </div>

        <div className="relative mt-8 md:mt-12 lg:mt-0">
          <Slider {...settings} className="w-full">
            <div>
              <img
                src="images/About.jpg"
                alt="Slide 1"
                className="w-full h-96 object-cover"
              />
            </div>
            <div>
              <img
                src="images/server2.jpg"
                alt="Slide 2"
                className="w-full h-96 object-cover"
              />
            </div>
            <div>
              <img
                src="images/server3.jpg"
                alt="Slide 3"
                className="w-full h-96 object-cover"
              />
            </div>
          </Slider>
        </div>
      </div>
    </div>
  );
}
